
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Save } from 'lucide-react';

interface EmailEditorHeaderProps {
  template: any;
  onBack: () => void;
  onSave: () => void;
  loadingAction: boolean;
  variablesValid: boolean;
}

export function EmailEditorHeader({ 
  template, 
  onBack, 
  onSave, 
  loadingAction,
  variablesValid
}: EmailEditorHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2">
        <Button 
          variant="ghost" 
          onClick={onBack} 
          className="flex items-center gap-1"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Back to Templates</span>
        </Button>
        <div className="ml-4">
          <h2 className="text-xl font-semibold">{template.name}</h2>
          <p className="text-sm text-muted-foreground">{template.template_id}</p>
        </div>
      </div>
      
      <Button 
        onClick={onSave}
        disabled={loadingAction || !variablesValid}
        className="flex items-center gap-1"
      >
        {loadingAction ? (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-background border-t-transparent"></div>
        ) : (
          <Save className="h-4 w-4" />
        )}
        <span>Save Changes</span>
      </Button>
    </div>
  );
}
